import React from 'react';
import { makeStyles, } from '@mui/styles';
import {
  Box, Theme, Typography,
} from '@mui/material';
import { useTheme, } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import ScrollAnimation from 'react-animate-on-scroll';
import BackgroudImage from '../assets/block1-background.png';
import MobileBackgroudImage from '../assets/block1-background-mobile.png';
import { FormattedMessage, } from 'react-intl';

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    position: 'relative',
    width: '100%',
    height: '400px',
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    paddingTop: '72px',
    [theme.breakpoints.down('md')]: { height: '300px', },
  },
  titleContainer: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-start',
    flexDirection: 'column',
    padding: '0 110px',
    top: 'calc(50% + 36px)',
    transform: 'translate(0, -50%)',
    [theme.breakpoints.down('md')]: { padding: '0 24px', },
  },
  titleBox: {
    width: 'fit-content',
    borderRadius: '10px',
    backgroundColor: 'rgba(133, 193, 31, 0.75);',
    padding: '8px 32px',
    marginBottom: '20px',
  },
}));

const BlockOne = () => {
  const classes = useStyles();
  const theme = useTheme();

  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  return (
    <Box
      className={classes.container}
      style={{ backgroundImage: `url(${isMobile ? MobileBackgroudImage : BackgroudImage})`, }}
    >
      <Box className={classes.titleContainer}>
        <Box className={classes.titleBox}>
          <Typography
            fontWeight="bold"
            color="white"
            fontSize={isMobile ? '16px' : '24px'}
          >
            <FormattedMessage id={'newspage.blockone.tag'} />
          </Typography>
        </Box>
        <ScrollAnimation className="fadeInDown">
          <Typography
            fontWeight="bold"
            color="white"
            fontSize={isMobile ? '24px' : '60px'}
          >
            <FormattedMessage id={'newspage.blockone.title'} />
          </Typography>
        </ScrollAnimation>
      </Box>
    </Box>
  );
};

export default React.memo(BlockOne);